module.exports = __webpack_public_path__ + "img/branding-logo-huisstijl-social-media-templates-instagram-apotheek-rodenbach-machelen-zulte-2.46819420.jpg";